import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectBeperktInzetbaarXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.29001 7L9.84001 9H10.88L8.81001 1.51C8.74001 1.2 8.45001 1 8.14001 1H7.86001C7.55001 1 7.26001 1.2 7.19001 1.51L3.74001 14H2.01001C1.73001 14 1.51001 14.22 1.51001 14.5C1.51001 14.78 1.73001 15 2.01001 15H10.01V14H4.78001L5.33001 12H10.01V11H5.61001L6.72001 7H9.29001ZM6.99001 6L8.00501 2.33804L9.02001 6H6.99001Z'
    />
    <path d='M14 7.52C14 7.24 13.78 7.02 13.5 7.02C13.22 7.02 13 7.24 13 7.52V12.52H14V7.52Z' />
    <path d='M14.25 14.5C14.25 14.9142 13.9142 15.25 13.5 15.25C13.0858 15.25 12.75 14.9142 12.75 14.5C12.75 14.0858 13.0858 13.75 13.5 13.75C13.9142 13.75 14.25 14.0858 14.25 14.5Z' />
  </svg>
);
export default SvgDefectBeperktInzetbaarXs;
